import { css } from '@emotion/react'

// TODO: TBI

export type Spacing = 'small' | 'medium' | 'large' | 'xlarge'

export const spacingVariants = {
  small: css``,
}
